<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-tieredMenu #menuContxtuelItem [popup]="true" [model]="menuContextuelItems" appendTo="body"></p-tieredMenu>

<div class="grid">

    <div class="col-12">

        <div class="fluid formgrid grid">
            <div class="flex flex-column gap-2 my-2 col-12 md:col-3">
                <label class="text-500">Type de garantie</label>
                <p-dropdown [options]="types" [(ngModel)]="type" optionLabel="nom" appendTo="body" filter="true"
                    filterBy="nom" [showClear]="true" placeholder="Sélectionnez un type...">
                    <ng-template pTemplate="selectedItem">
                        <div *ngIf="type()">
                            <div>{{type().nom}}</div>
                        </div>
                    </ng-template>
                    <ng-template let-type pTemplate="item">
                        <div>
                            <div>{{type.nom}}</div>
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>
            <div class="flex flex-column gap-2 my-2 col-12 md:col-3">
                <label class="text-500">Assigné à</label>
                <p-dropdown [options]="assignations" [(ngModel)]="assignationSelection" appendTo="body" filter="true"
                    [showClear]="true" placeholder="Sélectionnez une assignation...">
                    <ng-template pTemplate="selectedItem">
                        <div *ngIf="assignationSelection()">
                            <div>{{assignationSelection()}}</div>
                        </div>
                    </ng-template>
                    <ng-template let-assignation pTemplate="item">
                        <div>
                            <div>{{assignation}}</div>
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>

            <div class="col-12 md:col-6 lg:col-3">
                <label>&nbsp;</label>
                <button style="width: auto; margin-top: 22px; margin-right: 10px;" pButton pRipple label="Filtrer"
                    icon="pi pi-filter" class="p-button-primary" (click)="filtrer()"></button>
                <button style="width: auto; margin-top: 22px;" pButton pRipple label="Annuler" icon="pi pi-filter-slash"
                    class="p-button-secondary" (click)="retirerFiltres()"></button>
            </div>
        </div>


        <p-card>
            <p-table #dt [value]="items" [columns]="selectedColumns" dataKey="garantieId" autoLayout="true"
                tableStyleClass="tableNormale" [rowHover]="true" [totalRecords]="items?.length"
                [sortField]="tableParams.getValue().sortField" [sortOrder]="tableParams.getValue().sortOrder"
                [rows]="100" [paginator]="true" [rowsPerPageOptions]="[25,50,100,500]" [filterDelay]="0"
                [loading]="items == null"
                [globalFilterFields]="['item.numero','item.description','item.noSerie','item.noTag','item.modele','item.marque','item.sousCategorie.nom','item.categorie.nom','type.nom','description','dateFin','statut.nom','assignation']"
                (onFilter)="tableParams.setValue(dt)" (onSort)="tableParams.setValue(dt)"
                (onPage)="tableParams.setValue(dt)">

                <ng-template pTemplate="caption" let-state>
                    <div class="flex align-content-center justify-content-between">
                        <div>
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                    placeholder="Recherche..." autofocus />
                            </span>
                        </div>
                        <div>
                            <h5 class="titreTableau m-0">Garanties</h5>
                        </div>

                        <div>
                            <button pButton pRipple icon="pi pi-file-pdf"
                                class="p-button-secondary mr-2 ml-4 mb-2 boutonGrille" (click)="exportExcel()"></button>
                            <app-selecteur-colonnes [colonnesDisponibles]="colonnesDisponibles"
                                [(ngModel)]="colonnesSelectionnees" (onReset)="reinitialiserColonnesSelectionnees()">
                            </app-selecteur-colonnes>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pSortableColumn="item.numero">
                            <div class="flex justify-content-between align-items-center">
                                Numéro
                                <p-sortIcon field="item.numero"></p-sortIcon>
                                <p-columnFilter type="text" field="item.numero" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('description')" pSortableColumn="item.description">
                            <div class="flex justify-content-between align-items-center">
                                Description
                                <p-sortIcon field="item.description"></p-sortIcon>
                                <p-columnFilter type="text" field="item.description" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('categorie')" pSortableColumn="item.categorie?.nom">
                            <div class="flex justify-content-between align-items-center">
                                No Catégorie
                                <p-sortIcon field="item.categorie?.nom"></p-sortIcon>
                                <p-columnFilter type="text" field="item.categorie?.nom" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('sousCategorie')" pSortableColumn="item.sousCategorie?.nom">
                            <div class="flex justify-content-between align-items-center">
                                Sous catégorie
                                <p-sortIcon field="item.sousCategorie?.nom"></p-sortIcon>
                                <p-columnFilter type="text" field="item.sousCategorie?.nom" display="menu"
                                    class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('marque')" pSortableColumn="item.marque">
                            <div class="flex justify-content-between align-items-center">
                                Marque
                                <p-sortIcon field="item.marque"></p-sortIcon>
                                <p-columnFilter type="text" field="item.marque" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('modele')" pSortableColumn="item.modele">
                            <div class="flex justify-content-between align-items-center">
                                Modèle
                                <p-sortIcon field="item.modele"></p-sortIcon>
                                <p-columnFilter type="text" field="item.modele" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('type')" pSortableColumn="type.nom">
                            <div class="flex justify-content-between align-items-center">
                                Type
                                <p-sortIcon field="type.nom"></p-sortIcon>
                                <p-columnFilter type="text" field="type.nom" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('statut')" pSortableColumn="statut.nom">
                            <div class="flex justify-content-between align-items-center">
                                Statut
                                <p-sortIcon field="statut.nom"></p-sortIcon>
                                <p-columnFilter type="text" field="statut.nom" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('description2')" pSortableColumn="description">
                            <div class="flex justify-content-between align-items-center">
                                Description
                                <p-sortIcon field="description"></p-sortIcon>
                                <p-columnFilter type="text" field="description" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('dateFin')" pSortableColumn="dateFin">
                            <div class="flex justify-content-between align-items-center">
                                Date de fin
                                <p-sortIcon field="dateFin"></p-sortIcon>
                                <p-columnFilter type="date" field="dateFin" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('nbJoursRestants')" pSortableColumn="nbJoursRestants">
                            <div class="flex justify-content-between align-items-center">
                                Nb jours restants
                                <p-sortIcon field="nbJoursRestants"></p-sortIcon>
                                <p-columnFilter type="numeric" field="nbJoursRestants" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="assignation">
                            <div class="flex justify-content-between align-items-center">
                                Assigné à
                                <p-sortIcon field="assignation"></p-sortIcon>
                                <p-columnFilter field="assignation" matchMode="assignationContains" display="menu"
                                    [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                        <app-assignation-filter [(ngModel)]="selectionAssignations"
                                            (onChange)="filter($event)">
                                        </app-assignation-filter>
                                    </ng-template>
                                </p-columnFilter>
                            </div>
                        </th>
                        <ng-container *ngFor="let col of colonnesSelectionnees">
                            <th *ngIf="!col.base" [pSortableColumn]="'item.' + col.champ">
                                <div class="flex justify-content-between align-items-center">
                                    {{col.entete}}
                                    <p-sortIcon [field]="'item.' + col.champ"></p-sortIcon>
                                    <p-columnFilter [type]="ETypeChampAttribut[col.type]" [field]="'item.' + col.champ"
                                        display="menu" class="ml-auto">
                                    </p-columnFilter>
                                </div>
                            </th>
                        </ng-container>
                        <th style="min-width: 5rem"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-garantie>
                    <tr [pContextMenuRow]="garantie">
                        <td><a [routerLink]="['/item', garantie.item.itemId]">{{garantie.item.numero}}</a>
                        </td>
                        <td *ngIf="EstColonneSelectionnee('description')">{{garantie.item.description}}</td>
                        <td *ngIf="EstColonneSelectionnee('categorie')">{{garantie.item.categorie?.nom}}</td>
                        <td *ngIf="EstColonneSelectionnee('sousCategorie')">{{garantie.item.sousCategorie?.nom}}</td>
                        <td *ngIf="EstColonneSelectionnee('marque')">{{garantie.item.marque}}</td>
                        <td *ngIf="EstColonneSelectionnee('modele')">{{garantie.item.modele}}</td>
                        <td *ngIf="EstColonneSelectionnee('type')">{{garantie.type.nom}}</td>
                        <td *ngIf="EstColonneSelectionnee('statut')"><span
                                [class]="'statut ' + garantie.statut.nom.replace(' ','').toLowerCase()">
                                {{garantie.statut.nom}}
                            </span>
                        </td>

                        <td *ngIf="EstColonneSelectionnee('description2')">{{garantie.description}}</td>
                        <td *ngIf="EstColonneSelectionnee('dateFin')">{{garantie.dateFin | date:'yyyy-MM-dd'}}</td>

                        <td *ngIf="EstColonneSelectionnee('nbJoursRestants')">
                            <span *ngIf="garantie.nbJoursRestants"
                                [ngClass]="garantie.nbJoursRestants > seuilRouge ? garantie.nbJoursRestants > seuilJaune ? 'seuil vert' : 'seuil jaune' : 'seuil rouge'">
                                {{garantie.nbJoursRestants}}
                            </span>
                        </td>
                        <td>
                            <span *ngIf="garantie.item.emplacement">
                                <i class="pi pi-map-marker"></i> {{garantie.item.emplacement | nomEmplacement}}
                            </span>
                            <span *ngIf="garantie.item.employe">
                                <app-employe-avec-emplacement
                                    [employe]="garantie.item.employe"></app-employe-avec-emplacement>
                            </span>
                        </td>
                        <ng-container *ngFor="let col of colonnesSelectionnees">
                            <td *ngIf="col.type == ETypeChampAttribut.Texte">
                                {{garantie.item[col.champ]}}
                            </td>
                            <td *ngIf="col.type == ETypeChampAttribut.Numerique">
                                {{garantie.item[col.champ] | number:'1.0-0'}}
                            </td>
                            <td *ngIf="col.type == ETypeChampAttribut.Decimales">
                                {{garantie.item[col.champ] | number:'1.2-2'}}
                            </td>
                            <td *ngIf="col.type == ETypeChampAttribut.Date">
                                {{garantie.item[col.champ] | date:'yyyy/MM/dd'}}
                            </td>
                            <td *ngIf="col.type == ETypeChampAttribut.Booleen">
                                {{garantie.item[col.champ] ? 'Oui' : 'Non'}}
                            </td>
                        </ng-container>
                        <td>
                            <p-buttonGroup>
                                <p-button icon="pi pi-eye" severity="success" size="small"
                                    [routerLink]="['/item', garantie.item.itemId]" [queryParams]="{tab: '6'}"
                                    pTooltip="Voir l'item" pTooltipPosition="top"></p-button>
                                <p-button icon="pi pi-bars" severity="secondary" size="small"
                                    (click)="surMenuContextuelItem($event, garantie)"></p-button>
                            </p-buttonGroup>
                        </td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="13 + colonnesSelectionnees.length">Aucune garantie.</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="paginatorleft" let-state>
                    {{state.totalRecords}} entrée(s).
                </ng-template>
            </p-table>



        </p-card>
    </div>


</div>